import { createRouter, createWebHistory } from 'vue-router'
import Init from '@/views/Init/InitView.vue'
import Home from '@/views/Home/HomeView.vue'
import QA from '@/views/QA/QAView.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy/PrivacyPolicyView.vue'
import TermsOfService from '@/views/TermsOfService/TermsOfServiceView.vue'

const routes = [
  {
    path: '/',
    name: 'Init',
    component: Init
  },{
    path: '/Home',
    name: 'Home',
    component: Home
  },{
    path: '/QA',
    name: 'QA',
    component: QA
  },{
    path: '/PrivacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },{
    path: '/TermsOfService',
    name: 'TermsOfService',
    component: TermsOfService
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
